<template>
  <div class="whatson-view">
    <div class="whatson-top">
      <div class="whatson-top-banner" :style="`background-image: url(${getMediaHost(topBanner, 'WHATSON') + (blackAndWhite ? '?impolicy=bnw' : '')})`"></div>
      <section class="cx-sec">
        <div class="cx-wrap--page">
          <div class="cx-div--outer">
            <div class="cx-row -v-center">
              <div class="cx-div cx-col-md-12 cx-col-lg-12 whatson-title" :class="{ 'bnw-gray': blackAndWhite }">
                <span v-if="monthTitle" class="month-title"><i class="fas fa-book-open"></i> {{ monthTitle }}</span>
                <h2 class="cx-t20 m-title">{{ topIntroduction.title }}</h2>
              </div>
              <div class="cx-div cx-col-md-12 whatson-description" :class="promoVideo.length > 0 || promoBanner.length > 0 ? 'cx-col-lg-6' : 'cx-col-lg-12'">
                <div class="cx-t01 -fade" v-html="topIntroduction.description"></div>
              </div>
              <div v-show="promoVideo.length > 0 || promoBanner.length > 0" class="cx-div cx-col-md-12 cx-col-lg-6 whatson-video-slider">
                <div class="cx-div" style="position: relative; padding-bottom: 56.25%; border-radius: 5px; overflow: hidden;">
                  <div style="position: absolute; top: 0; right: 0; bottom: 0; left: 0;">
                  <cx-slider-v2 :key="`slider_${isMobile}_${isMobileView}_${promoVideo.length}_${promoBanner.length}`" :height="promoBanner.length > 0 ? 'auto' : '100%'" :draggable="true" :arrowNagv="false" cycling loop>
                    <template v-if="!(false && isMobile) && !(false && isMobileView) && promoVideo.length > 0">
                      <cx-slider-item v-for="videoLink in promoVideo" :key="videoLink" class="cx-media__video">
                        <cx-slide-video
                          :isMobile="(false && isMobile)"
                          :isMobileView="(false && isMobileView)"
                          :thumbnail="''"
                          :src="`${getMediaHost(videoLink, 'WHATSON')}`"
                          playsinline webkit-playsinline x5-playsinline
                        ></cx-slide-video>
                      </cx-slider-item>
                    </template>
                    <cx-slider-item v-for="(bannerPath, idx) in promoBanner" :key="bannerPath + idx">
                      <div class="cx-media--cover">
                        <cx-img
                          tag='div'
                          :imgSrc="`${getMediaHost(bannerPath, 'WHATSON')}`"
                          :key="bannerPath"
                          lazyLoad
                          class="cx-media__img m-hero__slide"
                        ></cx-img>
                      </div>
                    </cx-slider-item>
                  </cx-slider-v2>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="monthMenu.length > 0" class="cx-list">
              <div class="cx-list__item">
                <cx-dropdown class="months-filter-dropdown" trigger="click, hover" transition="cv-slidedown">
                  <span class="cx-link__icon">
                    <i class="fal fa-calendar-alt"></i>
                  </span>
                  <span>{{ $t('whatson.history') }}</span>
                  <template slot="content">
                    <ul class="cx-list cx-list--vertical cx-t01">
                      <li v-for="(month, idx) in monthMenu" :key="idx">
                        <a
                          :id="`m-${idx}`"
                          class="cx-link"
                          role="option"
                          @click.prevent="changeMonth(month)"
                        >
                          <span>{{ month.name }}</span>
                        </a>
                      </li>
                    </ul>
                  </template>
                </cx-dropdown>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <div class="whatson-main">
      <section class="cx-sec">
        <div class="cx-wrap--page">
          <div class="cx-div--outer">
            <div class="cx-row -v-center">
              <div class="cx-div cx-col-lg-4">
                <h2 class="cx-t20 m-title">{{ $t('whatson.highlights') }}</h2>
              </div>
              <div class="cx-div cx-col-lg-8">
                <div class="cx-row--halfgutter">
                  <div class="cx-div cx-col-xs-4 cx-col-md-4">
                    <rich-search-select
                      icon="fas fa-tag"
                      :name="$t('common.anyType')"
                      :options="filters.types"
                      :preset="null"
                      :selectedOption.sync="type"
                      style="width: 100%;"
                    ></rich-search-select>
                  </div>
                  <div class="cx-div cx-col-xs-8 cx-col-md-6">
                    <input
                      ref="keywordInput"
                      class="m-searchform__input -round-corner cx-field"
                      style="width: 100%;"
                      :placeholder="$t('enf.searchPlaceholder')"
                      type="text"
                      @keyup.enter="search(type, $refs.keywordInput.value)"
                    />
                  </div>
                  <div class="cx-div cx-col-xs-12 cx-col-md-2">
                    <button
                      class="cx-btn m-searchform__submit"
                      style="width: 100%;"
                      type="submit"
                      @click="search(type, $refs.keywordInput.value)"
                    >
                      <span><i class="fas fa-search"></i></span>
                      <span class="sr-only">{{ $t('action.search') }}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="cx-div--outer">
            <div class="cx-row--halfgutter">
              <div v-for="t in filterTypes" :key="t.value" class="cx-div cx-col-xs-6 cx-col-md-4 cx-col-lg-2">
                <button class="whatson-category-btn-pill" :class="{ 'bnw-gray': blackAndWhite }" :style="`background-color: ${t.backgroundColor}; color: ${t.color}; border-color: ${t.color}80;`" @click="$router.push(`${searchUrl}?month=${month}&type=${t.value}`)">
                  <span class="cx-link__icon"><i :class="t.iconClass"></i></span>
                  <b>{{ t.name }}</b>
                </button>
              </div>
              <div class="cx-div cx-col-xs-6 cx-col-md-4 cx-col-lg-2">
                <button class="whatson-category-btn-pill" :class="{ 'bnw-gray': blackAndWhite }" style="background-color: #F6F6F6; color: #4A4A4A; border-color: #4A4A4A80;" @click="$router.push(`${searchUrl}?month=${month}`)">
                  <span class="cx-link__icon"><i class="fas fa-clipboard-list"></i></span>
                  <b>{{ $t('whatson.allActivities') }}</b>
                </button>
              </div>
            </div>
          </div>
          <div class="cx-div--outer whatson-item-list">
            <div class="cx-row--halfgutter">
              <div class="cx-col-xs-12 cx-col-sm-6 cx-col-md-4 cx-col-lg-3" v-for="e in results" v-show="showAll || e.top === 'yes'" :key="e.id">
                <router-link-localed class="whatson-item-link cx-div" :to="e.to">
                  <div class="whatson-item-cover cx-div">
                    <div class="cx-media--cover" style="overflow: hidden; border-radius: 5px; border: 1px solid rgba(162, 162, 162, 0.2);">
                      <cx-img
                        tag='div'
                        :imgSrc="getMediaHost(e.thumbnail, 'WHATSON')"
                        faceFocus
                        square
                        lazyLoad
                        class="cx-media__img m-hero__slide"
                        style="padding-top: 100%"
                      ></cx-img>
                    </div>
                    <button v-if="atcbLoaded" class="whatson-item-todo-btn" @click.prevent.stop="addToCalendar($event.target, e)">
                      <i class="fas fa-calendar-plus"></i>
                    </button>
                  </div>
                  <h4 class="whatson-item-title" :title="e.name">{{ e.name }}</h4>
                  <p class="whatson-item-meta -fade" :class="{ 'bnw-gray': blackAndWhite }">
                    <span :style="`color: ${getEventType(e).color};`">{{ getEventType(e).name }}</span>
                    <span v-if="e.date"><i class="fal fa-calendar"></i> {{ e.date }}</span>
                    <span v-if="e.dateStatus" :class="getDateStatusClass(e)">{{ getDateStatusText(e) }}</span>
                    <span v-if="e.location && e.location.length > 0" style="display: block; margin-top: 8px;"><i class="fal fa-map-marker-alt"></i> {{ getEventLocation(e) }}</span>
                  </p>
                </router-link-localed>
              </div>
              <template v-if="isMounted && !showAll && results.some(r => r.top !== 'yes')">
                <div class="cx-col-xs-12 cx-col-sm-6 cx-col-md-4 cx-col-lg-3" key="showAll">
                  <a class="whatson-item-link cx-div" style="cursor: pointer;" @click.prevent.stop="showAll = !showAll">
                    <div class="whatson-item-cover cx-div">
                      <div class="cx-media--cover" :class="{ 'bnw-gray': blackAndWhite }" style="overflow: hidden; border-radius: 5px; border: 1px solid rgba(162, 162, 162, 0.2);">
                        <cx-img
                          tag='div'
                          :imgSrc="'/static/whatson/showAll.jpg'"
                          faceFocus
                          square
                          lazyLoad
                          class="cx-media__img m-hero__slide"
                          style="padding-top: 100%"
                        ></cx-img>
                      </div>
                    </div>
                    <h4 class="whatson-item-title" style="cursor: pointer;">{{ $t('whatson.allActivities') }}</h4>
                    <p class="whatson-item-meta -fade"></p>
                  </a>
                </div>
              </template>
            </div>
          </div>
        </div>
      </section>
    </div>

    <div class="whatson-bottom">
      <section class="cx-sec">
        <div class="cx-wrap--page">
          <div class="cx-div--outer">
            <div class="cx-row--halfgutter">
              <div class="cx-div cx-col-md-12 cx-col-lg-9 whatson-bottom-text">
                <div class="cx-row">
                  <div class="cx-div cx-col-md-6 cx-col-lg-7">
                    <h3 style="font-weight: 600;">{{ $t('whatson.preview') }}</h3>
                    <div class="-fade" v-html="nextMonthPreview"></div>
                  </div>
                  <div class="cx-div cx-col-md-6 cx-col-lg-5">
                    <h3 style="font-weight: 600;">{{ $t('whatson.ticketing') }}</h3>
                    <div class="-fade" v-html="ticketingInfo"></div>
                  </div>
                </div>
              </div>
              <div class="cx-div cx-col-md-12 cx-col-lg-3 whatson-bottom-makmak">
                <div class="cx-div" :class="{ 'bnw-gray': blackAndWhite }">
                  <cx-img
                    tag="i"
                    class="m-graphic--information"
                    imgSrc="/static/graphic/mgto_graphic_makmakevent.png"
                  ></cx-img>
                </div>
              </div>
            </div>
          </div>
          <div class="cx-div--outer">
            <hr style="border: 0; border-top: 1px solid #EDEBE8;" />
            <br />
          </div>
          <div class="cx-div--outer m-happening__actions">
            <div class="cx-list cx-t00">
              <span v-show="$t('enf.eventCalendar')" class="cx-list__item">
                <router-link-localed to="/events/calendar" class="cx-link">
                  <span class="cx-link__icon">
                    <i class="fa-fw fa-2x fal fa-calendar-star"></i>
                  </span>
                  <span class="cx-link__text">
                    {{ $t('enf.eventCalendar') }}
                  </span>
                </router-link-localed>
              </span>
              <span v-show="$t('whatson.download')" class="cx-list__item">
                <!-- <a href="https://whatson.macaotourism.gov.mo/pdf.php" target="_blank" class="cx-link"> -->
                <router-link-localed to="/whatson/download" class="cx-link">
                  <span class="cx-link__icon">
                    <i class="fa-fw fa-2x fal fa-book-open"></i>
                  </span>
                  <span class="cx-link__text">
                    {{ $t('whatson.download') }}
                  </span>
                </router-link-localed>
                <!-- </a> -->
              </span>
              <span v-if="false" class="cx-list__item">
                <a :href="$t('footer.eNewsLink')" target="_blank" class="cx-link">
                  <span class="cx-link__icon">
                    <i class="fa-fw fa-2x fal fa-bullhorn"></i>
                  </span>
                  <span class="cx-link__text">
                    {{ $t('footer.eNews') }}
                  </span>
                </a>
              </span>
              <span v-show="$t('whatson.enquiry')" class="cx-list__item">
                <a :href="$t('whatson.enquiryLink')" target="_blank" class="cx-link">
                  <span class="cx-link__icon">
                    <i class="fa-fw fa-2x fal fa-question-circle"></i>
                  </span>
                  <span class="cx-link__text">
                    {{ $t('whatson.enquiry') }}
                  </span>
                </a>
              </span>
              <span v-show="$t('whatson.suggestion')" class="cx-list__item">
                <a :href="$t('whatson.suggestionLink')" target="_blank" class="cx-link">
                  <span class="cx-link__icon">
                    <i class="fa-fw fa-2x fal fa-calendar-plus"></i>
                  </span>
                  <span class="cx-link__text">
                    {{ $t('whatson.suggestion') }}
                  </span>
                </a>
              </span>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';
import RichSearchSelect from '@/components/RichSearchSelect';
import eventHelper from '@/mixins/eventHelper';
import headerUpdater from '@/mixins/headerUpdater';
import getMacauDateTime from '@/utils/getMacauDateTime';
import { getMonthFilter } from '@/store/modules/events';

export default {
  name: 'whatson-view',
  mixins: [eventHelper, headerUpdater({ firePageLoadedEvent: true })],
  components: {
    RichSearchSelect,
  },
  asyncData({ i18n, store, route }) {
    let { month="" } = route.query;
    let m = month;
    if (!m) {
      // const date = getMacauDateTime();
      // const year = date.getFullYear();
      // const month = date.getMonth() + 1;
      // m = `${year}${month < 10 ? '0' + month : month}`;
    }
    return Promise.all([
      store.dispatch('events/FETCH_FILTER', { locale: i18n.locale }),
      store.dispatch('events/SEARCH_EVENT', { locale: i18n.locale, m, filterMonth: false, filterLocation: false, isWhatsonEntry: true }),
      // store.dispatch('whatson/FETCH_WHATSONS', { locale: i18n.locale }),
      store.dispatch('whatson/FETCH_WHATSON_PDFS', { locale: i18n.locale }),
    ]);
  },
  header() {
    return {
      title: this.$t('whatson.highlights') || this.topIntroduction.title,
      ogImg: this.getMediaHost(this.topBanner, 'WHATSON'),
      desc: this.parseHtmlToShortDesc(this.topIntroduction.description)
    }
  },
  uit() {
    return [
      ['action', ['search']],
      ['common', ['anyType']],
      ['footer', [
        'eNews',
        'eNewsLink'
      ]],
      ['whatson', [
        'month',
        'history',
        'allActivities',
        'preview', 'ticketing',
        'highlights', 'download', 'enquiry', 'suggestion',
        'enquiryLink', 'suggestionLink'
      ]],
      ['enf', [
        'searchPlaceholder', 'eventCalendar',
        'searchHeader',
        'inProgress', 'upComing', 'ended', 'nDaysBeforeStart',
        'nDaysBeforeEnd', '1DayBeforeStart',
        '1DayBeforeEnd', 'searchCaption',
        'majorEvent'
      ]]
    ]
  },
  data() {
    return {
      searchUrl: `/events/whatson`,
      month: '',
      type: '',
      keyword: '',
      showAll: false,

      isMounted: false,

      atcbCssLoaded: false,
      atcbJsLoaded: false,

      // monthMenuChecked: false,
      monthMenuCheckedCount: -1,
      monthMenuCheckedTotal: 0,
    };
  },
  computed: {
    ...mapState({
      isMobile: state => state.ui.isMobile,
      isMobileView: state => state.ui.isMobileView,
      blackAndWhite: state => state.ui.blackAndWhite,
    }),
    atcbLoaded: function() {
      return this.atcbCssLoaded && this.atcbJsLoaded;
    },
    monthTitle: function() {
      if (!this.month) {
        return '';
      }
      const year = this.month.slice(0, 4);
      const month = this.month.slice(4);
      // return `${year}年 ${+month}月刊`;
      return `${this.$t('whatson.month')}${this.$i18n.locale === 'zh-hant' || this.$i18n.locale === 'zh-hans' ? '：' : ': '}${year}/${+month}`;
    },
    monthMenuChecked: function() {
      return this.monthMenuCheckedCount === this.monthMenuCheckedTotal;
    },
    monthFilters: function() {
      const { months } = this.$store.getters['events/getMonthFilter'](this.$route.query.month) || {};
      if (months) {
        const monthesToCheck = [];
        if (months[0]) {
          monthesToCheck.push(months[0]);
        }
        if (months[1]) {
          monthesToCheck.push(months[1]);
        }
        this.monthMenuCheckedTotal = monthesToCheck.length;
        this.monthMenuCheckedCount = 0;
        // check latest 2 monthes does have content: https://3.basecamp.com/3633946/buckets/6317965/todos/7777224685
        for (let i = 0; i < this.monthMenuCheckedTotal; i++) {
          const m = monthesToCheck[i];
          axios.get(encodeURI(`/api/enf/whatson?m=${m.value}`)).then(res => {
            if (res.data && res.data.resultCount) {
              //
            } else {
              m.hidden = true;
            }
          }).catch(err => {
            // console.log(err);
          }).finally(() => {
            this.monthMenuCheckedCount++;
          });
        }
      }
      return { months: this.$route.meta.showAllWhatsonMonths ? months || [] : (months || []).slice(0, 2) };
    },
    monthMenu: function() {
      const months = this.monthFilters.months.filter(m => !m.hidden);
      return this.monthMenuChecked ? months : [];
    },
    filters: function() {
      return this.$store.getters['events/getFilter'](this.$i18n.locale) || {};
    },
    filterTypes: function() {
      return (this.filters.types || []).map(t => {
        // 節日盛事
        if (t.value === '1') {
          t.backgroundColor = '#FFEFE0';
          t.color = '#E07009';
          t.iconClass = 'fas fa-award';
        }
        // 表演
        if (t.value === '2') {
          t.backgroundColor = '#FCE2E4';
          t.color = '#C7285A';
          t.iconClass = 'fas fa-theater-masks';
        }
        // 體育
        if (t.value === '3') {
          t.backgroundColor = '#E7EBF5';
          t.color = '#073CAD';
          t.iconClass = 'fas fa-running';
        }
        // 展覽
        if (t.value === '14') {
          t.backgroundColor = '#ECFBF6';
          t.color = '#057A55';
          t.iconClass = 'fas fa-university';
        }
        // 其他
        if (t.value === '5') {
          t.backgroundColor = '#F4E4F2';
          t.color = '#7907AD';
          t.iconClass = 'fas fa-icons';
        }
        return t;
      });
    },
    // whatson: function() {
    //   const whatson = this.$store.getters['whatson/getWhatsons'](this.$i18n.locale);
    //   return whatson || {};
    // },
    // whatsons: function() {
    //   return (this.whatson.results || []).filter(e => {
    //     // if (this.keyword) {
    //     //   let matched = false;
    //     //   if (e.name) {
    //     //     matched = e.name.toLowerCase().indexOf(this.keyword.toLowerCase()) > -1;
    //     //   }
    //     //   // if (e.shortDesc) {
    //     //   //   matched = matched || e.shortDesc.toLowerCase().indexOf(this.keyword.toLowerCase()) > -1;
    //     //   // }
    //     //   if (e.types && e.types.length > 0) {
    //     //     matched = matched || e.types.some(t => (t.name || '').toLowerCase().indexOf(this.keyword.toLowerCase()) > -1);
    //     //   }
    //     //   if (e.location && e.location.length > 0) {
    //     //     matched = matched || e.location.some(l => (l.name || '').toLowerCase().indexOf(this.keyword.toLowerCase()) > -1);
    //     //   }
    //     //   return matched;
    //     // }
    //     return true;
    //   });
    // },
    topUI: function() {
      const top = this.$store.getters['events/getTopUI']();
      return top;
    },
    searchedMonth: function() {
      return this.$store.getters['events/getSearchedMonth']();
    },
    results: function() {
      let { month="", type="", keyword="" } = this.$route.query;
      let qs = [];

      month && qs.push(`month=${month}`);
      type && qs.push(`type=${type.replace('&', '%26')}`);
      keyword && qs.push(`keyword=${keyword}`);

      qs = qs.length > 0
        ? `?${qs.join('&')}`
        : '';

      const res = this.$store.getters['events/getSearchResult']({ isWhatsonEntry: true }).map(r => {
        return {
          ...r,
          date: r.showDate,
          to: `/events/whatson/${r.id}${qs}`
        }
      });

      const top = res.filter(r => r.top === 'yes');
      const notTop = res.filter(r => r.top !== 'yes');

      return [...top, ...notTop];
    },
    topBanner: function() {
      return this.topUI && this.topUI.banner;
    },
    topIntroduction: function() {
      return this.topUI && this.topUI.introduction || {};
    },
    promoVideo: function() {
      return this.topUI && this.topUI.promoVideo || [];
    },
    promoBanner: function() {
      return this.topUI && this.topUI.promoBanner || [];
    },
    nextMonthPreview: function() {
      return this.topUI && this.topUI.nextMonthPreview;
    },
    ticketingInfo: function() {
      return this.topUI && this.topUI.ticketingInfo;
    },
  },
  watch: {
    searchedMonth: {
      handler: function(m) {
        this.month = m || '';
      },
      immediate: true
    },
  },
  beforeRouteEnter(to, from, next) {
    if (!to.meta.showAllWhatsonMonths && to.query.month) {
      const date = getMacauDateTime();
      const year = `${date.getFullYear()}`;
      const month = `${date.getMonth() + 1}`.padStart(2, '0');
      const now = parseInt(`${year}${month}`);
      const future = parseInt(to.query.month) > now;
      if (future) {
        return next();
      }
      const { months } = getMonthFilter();
      const latestTwoMonths = months.slice(0, 2);
      if (
        (latestTwoMonths[0] && latestTwoMonths[0].value === to.query.month) ||
        (latestTwoMonths[1] && latestTwoMonths[1].value === to.query.month)
      ) {
        // next();
      } else {
        return next({ name: to.name, query: {} });
      }
    }
    next();
  },
  mounted() {
    const topResults = this.results.filter(r => r.top === 'yes');
    if (topResults.length === 0) {
      this.showAll = true;
    }
    this.isMounted = true;

    // this.atcbEnable();
  },
  methods: {
    atcbEnable() {
      const atcbCss = document.createElement('link');
      atcbCss.rel = 'stylesheet';
      atcbCss.href = 'https://cdn.jsdelivr.net/npm/add-to-calendar-button@1.14.4/assets/css/atcb.min.css';
      atcbCss.onload = () => this.atcbCssLoaded = true;
      document.head.appendChild(atcbCss);

      const atcbJs = document.createElement('script');
      atcbJs.src = 'https://cdn.jsdelivr.net/npm/add-to-calendar-button@1.14.4';
      atcbJs.async = true;
      atcbJs.defer = true;
      atcbJs.onload = () => this.atcbJsLoaded = true;
      document.body.appendChild(atcbJs);
    },
    getEventType(e) {
      let type = (e.types || [])[0] || {};
      const t = this.filterTypes.find(t => t.value === type.value);
      if (t) {
        type = {
          ...t,
          ...type,
        }
      }
      return type;
    },
    getDateStatusText(e) {
      return this.getWhatsonDateStatusText({
        dateStatus: e.dateStatus,
        daysBeforeStart: e.daysBeforeStart,
        daysBeforeEnd: e.daysBeforeEnd,
      });
    },
    getDateStatusClass(e) {
      return this.getWhatsonDateStatusClass({
        dateStatus: e.dateStatus,
        daysBeforeStart: e.daysBeforeStart,
        daysBeforeEnd: e.daysBeforeEnd,
      });
    },
    getEventDate(e, obj = false) {
      if (!e.month) {
        return '';
      }
      let [y, m] = e.month.split('-');
      let startDate, mStart, dStart;
      let endDate, mEnd, dEnd;
      if (e.eventDateRange.length > 0) {
        startDate = e.eventDateRange[0][0] || '';
        mStart = startDate.split('-')[1];
        dStart = startDate.split('-')[2];
        endDate = e.eventDateRange[e.eventDateRange.length - 1][1] || '';
        mEnd = endDate.split('-')[1];
        dEnd = endDate.split('-')[2];
      } else {
        mStart = m;
        dStart = '01'; // first day of month
        startDate = `${y}-${mStart}-${dStart}`;
        mEnd = m;
        dEnd = new Date(+y, +m, 0).getDate(); // last day of month
        endDate = `${y}-${mEnd}-${dEnd}`;
      }
      if (obj) {
        return { startDate, endDate };
      }
      mStart = +mStart;
      dStart = +dStart;
      mEnd = +mEnd;
      dEnd = +dEnd;
      if (mStart === mEnd && dStart === dEnd) {
        return `${dStart}/${mStart}`;
      }
      if (mStart === mEnd) {
        return `${dStart}-${dEnd}/${mStart}`;
      }
      if (mStart !== mEnd) {
        return `${dStart}/${mStart} - ${dEnd}/${mEnd}`;
      }
      return `${+m}/${y}`;
    },
    getEventLocation(e) {
      if (!e.location) {
        return '';
      }
      if (Array.isArray(e.location)) {
        return e.location.map(l => l.name).join(', ');
      }
      return e.location;
    },
    addToCalendar(triggerEl, event) {
      const atcb_action = window.atcb_action;
      if (atcb_action) {
        const { startDate, endDate } = this.getEventDate(event, true);
        const location = this.getEventLocation(event);
        const config = {
          name: event.name,
          description: event.shortDesc,
          startDate,
          endDate,
          location,
          options: [
            'Apple',
            'Google',
            'iCal',
            'Microsoft365',
            'Outlook.com',
            'MicrosoftTeams',
            'Yahoo',
          ],
          timeZone: 'Asia/Macau',
          trigger: 'click',
          listStyle: 'overlay',
          iCalFileName: 'MGTO-whatson-event',
        };
        console.log(config, event);
        atcb_action(config, triggerEl);
      }
    },
    changeMonth(month) {
      this.$router.replace({
        ...this.$route,
        query: {
          ...this.$route.query,
          month: month.value,
        }
      });
    },
    search(type = '', keyword = '') {
      // whatson 首頁的快速搜尋（使用 $refs.keywordInput.value）也需要統一 trim
      keyword = (keyword || '').trim();
      
      this.month = this.$route.query.month && this.searchedMonth;
      this.type = type;
      this.keyword = keyword;

      let qs = [];

      this.month && qs.push(`month=${this.month}`);
      this.type && qs.push(`type=${this.type.replace('&', '%26')}`);
      this.keyword && qs.push(`keyword=${this.keyword}`);

      qs = qs.length > 0
        ? `?${qs.join('&')}`
        : '';

      this.$router.push(this.searchUrl + qs);
    },
  },
};
</script>

<style lang="scss" scoped>
.whatson-top {
  background-color: #f9f7f4;
}

.whatson-top-banner {
  position: relative;
  padding-top: 45%;
  background-color: #ffffff;
  background-size: cover;
  background-position: center left;
  background-repeat: no-repeat;
}
@media (min-width: $breakpoint-lg) {
  .whatson-top-banner {
    padding-top: 25%;
  }
}

.whatson-title {
  order: 1;
}
.whatson-description {
  order: 3;
}
.whatson-video-slider {
  order: 2;
  margin-bottom: 1rem;
}
@media (min-width: $breakpoint-lg) {
  .whatson-title {
    order: 1;
  }
  .whatson-description {
    order: 2;
  }
  .whatson-video-slider {
    order: 3;
    margin-bottom: 0;
  }
}

button.whatson-category-btn-pill {
  appearance: none;
  border-radius: 999px;
  width: 100%;
  padding: 10px 16px;
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  white-space: nowrap;
  border: 1px solid currentColor;
  .cx-link__icon {
    transform: scale(1.2);
  }
  b {
    padding: 0 4px;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    overflow-wrap: break-word;
    white-space: normal;
  }
  cursor: pointer;
}
button.whatson-category-btn-pill::after {
  content: "";
}
@media (min-width: $breakpoint-md) {
  button.whatson-category-btn-pill {
    padding: 16px 24px;
    .cx-link__icon {
      transform: scale(1.5);
    }
    b {
      padding: 0 12px;
      white-space: nowrap;
    }
  }
}

.whatson-item-list {
  margin-top: 3rem;
}
@media (min-width: $breakpoint-md) {
  .whatson-item-list {
    margin-top: 1rem;
  }
}
@media (min-width: $breakpoint-lg) {
  .whatson-item-list {
    margin-top: 0;
  }
}

a.whatson-item-link:not(:hover) {
  color: inherit;
}
.whatson-item-link {
  line-height: normal;
  margin-bottom: 1.5rem;
  user-select: none;
  // cursor: default;
}
.whatson-item-cover {
  position: relative;
}
.whatson-item-todo-btn {
  position: absolute;
  right: 0;
  bottom: 0;
  margin: 16px 18px;
  appearance: none;
  outline: none;
  border: 0;
  padding: 0;
  background: transparent;
  color: white;
  opacity: 0.8;
  transition: 200ms;
}
.whatson-item-todo-btn:hover {
  cursor: pointer;
  opacity: 1;
}
.whatson-item-todo-btn i.fas {
  font-size: 2em;
  filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.25));
  opacity: 0.8;
  transition: 300ms;
}
.whatson-item-todo-btn:hover i.fas {
  opacity: 1;
}
.whatson-item-title {
  // display: inline-block;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 8px;
  font-weight: 700;
  user-select: auto;
  cursor: text;
}
.whatson-item-meta {
  display: inline-block;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: smaller;
  user-select: auto;
  cursor: text;
}
@media (min-width: $breakpoint-lg) {
  .whatson-item-meta {
    font-size: small;
  }
}
.whatson-item-meta > span:not(:first-child) {
  font-weight: 500;
}
.whatson-item-meta > span:not(:last-child) {
  margin-right: 10px;
}
@media (min-width: $breakpoint-lg) {
  .whatson-item-meta > span:not(:last-child) {
    margin-right: 20px;
  }
}

.whatson-bottom {
  background-color: #f9f7f4;
}

.whatson-bottom-text {
  order: 2;
  margin-bottom: 2rem;
  .cx-row {
    .cx-div + .cx-div {
      margin-top: 1rem;
    }
  }
}
.whatson-bottom-makmak {
  order: 1;
  .m-graphic--information {
    height: 300px;
    margin-bottom: 3rem;
  }
}
@media (min-width: $breakpoint-sm) {
  .whatson-bottom-makmak {
    .m-graphic--information {
      height: 200px;
    }
  }
}
@media (min-width: $breakpoint-md) {
  .whatson-bottom-text {
    order: 1;
    margin-bottom: 0;
    .cx-row {
      .cx-div + .cx-div {
        margin-top: 0;
      }
    }
    .m-graphic--information {
      height: 150px;
      margin-bottom: 0;
    }
  }
  .whatson-bottom-makmak {
    order: 2;
  }
}

.m-happening__actions {
  margin-bottom: 0 !important;
  a {
    @extend %style-text-link;
    margin-bottom: .25rem;
  }
}

@media (max-width: $breakpoint-lg) {
  .whatson-top > .cx-sec,
  .whatson-main > .cx-sec,
  .whatson-bottom > .cx-sec {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
  .whatson-item-link {
    margin-bottom: 0;
  }
}
</style>

<style>
.months-filter-dropdown .cx-dropdown__content {
  max-height: 250px;
}

.whatson-title .m-title:before {
  content: none;
}
.whatson-title .month-title {
  color: #d7192e;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  margin-bottom: 1rem;
}
.whatson-title .month-title i {
  margin-right: 0.5em;
}
</style>
